import React, { useRef } from "react";
import Navbar from "components/layout/Navbar";
import HomeSection from "./HomeSection";
import About from "./About";
import Teacher from "./Teacher";
import Events from "./Events";
import Comment from "./Comment";
import Developers from "./Developers";
import Footer from "./Footer";

import ApplyForm from "./ApplyForm";
import FloatingApplyButton from "components/ui/FloatingApplyButton";

import "styles/public.css";
import "styles/panel.css";

const Home = () => {
  const applyFormRef = useRef(null);

  const handleOpenApply = () => {
    applyFormRef.current?.openModal?.();
  };

  return (
    <div className="home-page">
      <Navbar />

      <HomeSection />
      <About />
      <Teacher />
      <Events />
      <Comment />
      <Developers />

      <ApplyForm ref={applyFormRef} />

      <FloatingApplyButton onOpen={handleOpenApply} />

      <Footer />
    </div>
  );
};

export default Home;
